'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import type { Character } from '../types';

export async function setPrimaryPortrait(
  characterId: string,
  portraitId: string,
): Promise<ActionResult<Character>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const { getCharacterImageService } = await import('@/contexts/characters/services/CharacterImageService');
    const updated = await getCharacterImageService().setPrimaryPortrait(
      characterId,
      familyId,
      portraitId,
    );

    return { success: true, data: updated as Character };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('setPrimaryPortrait', e) };
  }
}
